import React from 'react'
import {Switch, Route} from 'react-router-dom'

import EstateLayout from 'components/shared/EstateLayout'
import Product from './Product'
import ProductCorrection from './ProductCorrection'
import ProductCustomProfile from './ProductCustomProfile'
import ApproveProduct from './ApproveProduct'
import Orders from './Orders'
import AreaPhotos from './AreaPhotos'
import Sharings from './Sharings'
import EstateInfo from './EstateInfo'
import EstateDashboard from './EstateDashboard'

const Estate = ({match}) => {
  return (
    <EstateLayout match={match}>
      <Switch>
        <Route path={`${match.path}/produkt/:productId/korreksjon`} component={ProductCorrection} />
        <Route path={`${match.path}/produkt/:productId/fotofilter`} component={ProductCustomProfile} />
        <Route path={`${match.path}/produkt/:productId`} component={Product} />
        <Route path={`${match.path}/godkjenn-leveranse/:productId`} component={ApproveProduct} />
        <Route path={`${match.path}/ordre`} component={Orders} />
        <Route path={`${match.path}/omradebilder`} component={AreaPhotos} />
        <Route path={`${match.path}/deling`} component={Sharings} />
        <Route path={`${match.path}/boliginfo`} component={EstateInfo} />
        <Route path={match.path} component={EstateDashboard} />
      </Switch>
    </EstateLayout>
  )
}

export default Estate
